import LocalizedStrings from "react-localization";

export const dataAssignmentFiltersStrings = new LocalizedStrings({
  en: {
    status: "Status",
    adPaid: "Ad Paid",
    adPaidTextExclusions: "Ad Paid Text Exclusion",
    adName: "Ad Name",
    startDate: "Start date",
    endDate: "End date",
    search: "Search",
    statuses: {
      All: "All",
      Brand: "Brand",
      Reseller: "Reseller",
      Exclude: "Exclude",
      NotMapped: "Not Mapped",
    },
  },
  fr: {
    status: "Statut",
    adPaid: "Ad Paid",
    adPaidTextExclusions: "Ad Paid Text Exclusion",
    adName: "Ad Name",
    startDate: "Date de début",
    endDate: "Date de fin",
    search: "Recherche",
    statuses: {
      All: "Tout",
      Brand: "Brand",
      Reseller: "Reseller",
      Exclude: "Exclure",
      NotMapped: "A Faire",
    },
  },
});
